import { SVGIcon } from '../Icons'
import { ISVGProps } from '../types'

const Ruler = (props: ISVGProps) => (
  <SVGIcon {...props}>
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.4999 5H2.49992C1.58325 5 0.833252 5.75 0.833252 6.66667V13.3333C0.833252 14.25 1.58325 15 2.49992 15H17.4999C18.4166 15 19.1666 14.25 19.1666 13.3333V6.66667C19.1666 5.75 18.4166 5 17.4999 5ZM17.4999 13.3333H2.49992V6.66667H4.16658V10H5.83325V6.66667H7.49992V10H9.16658V6.66667H10.8333V10H12.4999V6.66667H14.1666V10H15.8333V6.66667H17.4999V13.3333Z"
        fill="#242424"
      />
    </svg>
  </SVGIcon>
)

export default Ruler
